class PartnersItem extends Component {
    constructor(el) {
        super(el);
    }

}
